import { render, staticRenderFns } from "./sales-filter-counter.vue?vue&type=template&id=21fab800"
import script from "./sales-filter-counter.vue?vue&type=script&lang=js"
export * from "./sales-filter-counter.vue?vue&type=script&lang=js"
import style0 from "./sales-filter-counter.vue?vue&type=style&index=0&id=21fab800&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports